export const primary = {
  50: "#EDFCF5",
  100: "#D3F8E4",
  200: "#ABEFCF",
  300: "#74E1B4",
  400: "#3CCB94",
  500: "#19B880",
  600: "#0C8F63",
  700: "#0A7253",
  800: "#0A5B42",
  900: "#094B38",
  950: "#042A20",
};
export const secondary = {
  50: "#EFF8FF",
  100: "#DEF1FF",
  200: "#B6E4FF",
  300: "#75D1FF",
  400: "#2DB9FF",
  500: "#10ABFE",
  600: "#0080D3",
  700: "#0065AA",
  800: "#00568C",
  900: "#064874",
  950: "#042D4D",
};
export const nuetral = {
  50: "#F8FAFC",
  100: "#F1F5F9",
  200: "#E2E8F0",
  300: "#CBD5E1",
  400: "#94A3B8",
  500: "#64748B",
  600: "#475569",
  700: "#334155",
  800: "#1E293B",
  900: "#0F172A",
  950: "#020618",
};
